const categoryTypes: { [key: string]: string } = {
  CategoryTreeFacet: 'CategoryTreeFacet',
};

export default categoryTypes;
